import { MedicalCategory, MedicalCategoryProperty, MedicalCategoryPropertyValue } from 'model/graphql';
import React, { useContext, useMemo, useState } from 'react';
import refreshIcon from 'assets/icons/ic_refresh.svg?url';
import closeIcon from 'assets/icons/ic_close_w.svg?url';
import FixSwipeable from 'components/atoms/FixSwipeable';
import { AnalyticsContext } from 'contexts/AnalyticsContext';
import * as styles from './styles';

const MAX_LINE_FOR_SHOWING_CATEGORY_PROPERTIES = 4;

export default function MedicalFilterView({
  medicalCategoryProperties,
  selectedPropertyValueIds,
  onChanged,
  category,
  subcategory,
}: {
  medicalCategoryProperties: MedicalCategoryProperty[];
  selectedPropertyValueIds: string[];
  onChanged: (selectedIds: string[] | null) => void;
  category?: MedicalCategory;
  subcategory?: MedicalCategory;
}) {
  const { trackEvent } = useContext(AnalyticsContext);
  const [isExpanded, setExpanded] = useState<boolean>(false);

  let categoryProperties = medicalCategoryProperties;
  if (!isExpanded && categoryProperties.length >= MAX_LINE_FOR_SHOWING_CATEGORY_PROPERTIES) {
    categoryProperties = categoryProperties.slice(0, MAX_LINE_FOR_SHOWING_CATEGORY_PROPERTIES);
  }

  const selectedValues: MedicalCategoryPropertyValue[] = useMemo(() => {
    const filteredValues = medicalCategoryProperties.reduce(
      (medicalCategoryPropertyValues, medicalCategoryProperty) =>
        // eslint-disable-next-line no-param-reassign
        [
          ...medicalCategoryPropertyValues,
          ...medicalCategoryProperty.medicalCategoryPropertyValues.filter((medicalCategoryPropertyValue) =>
            selectedPropertyValueIds.includes(medicalCategoryPropertyValue.id)
          ),
        ],
      []
    );
    return filteredValues;
  }, [medicalCategoryProperties, selectedPropertyValueIds]);

  return (
    <>
      {categoryProperties.map((item) => (
        <FixSwipeable key={item.id}>
          <div className={styles.titledScrollableItemView}>
            <div className={styles.scrollableItemTitle}>{item.name}</div>
            <div className={styles.scrollableItemView()}>
              {item.medicalCategoryPropertyValues.map((value) => (
                <span
                  key={Number(value.id)}
                  className={styles.filterItem(selectedPropertyValueIds.includes(value.id))}
                  onClick={() => {
                    if (selectedPropertyValueIds.includes(value.id)) {
                      trackEvent('clinic_productList_categoryFilter_click', {
                        level1CategoryId: category?.id,
                        level1CategoryName: category?.name,
                        level2CategoryId: subcategory?.id,
                        level2CategoryName: subcategory?.name,
                        filterCategoryId: item.id,
                        filterCategoryName: item.name,
                        filterId: value.id,
                        filterName: value.name,
                        action: 'cancel',
                      });
                      onChanged(
                        selectedPropertyValueIds.filter(
                          (selectedPropertyValueId) => selectedPropertyValueId !== value.id
                        )
                      );
                    } else {
                      trackEvent('clinic_productList_categoryFilter_click', {
                        level1CategoryId: category?.id,
                        level1CategoryName: category?.name,
                        level2CategoryId: subcategory?.id,
                        level2CategoryName: subcategory?.name,
                        filterCategoryId: item.id,
                        filterCategoryName: item.name,
                        filterId: value.id,
                        filterName: value.name,
                        action: 'add',
                      });

                      onChanged([...selectedPropertyValueIds, value.id]);
                    }
                  }}
                >
                  {value.name}
                </span>
              ))}
            </div>
          </div>
        </FixSwipeable>
      ))}
      {selectedValues && selectedValues.length > 0 && (
        <FixSwipeable>
          <div className={styles.titledScrollableItemView}>
            <div className={styles.scrollableItemView('10px')}>
              {selectedValues.map((value) => (
                <div
                  className={styles.tag}
                  key={Number(value.id)}
                  onClick={() => {
                    trackEvent('clinic_productList_categoryFliter_delete', {
                      filterId: value.id,
                      filterName: value.name,
                    });
                    onChanged(
                      selectedPropertyValueIds.filter((selectedPropertyValueId) => selectedPropertyValueId !== value.id)
                    );
                  }}
                >
                  {value.name}
                  <div className={styles.filterDeleteButton}>
                    <img src={closeIcon} alt="X" />
                  </div>
                </div>
              ))}
            </div>
            <div className={styles.scrollableItemTitle}>
              <div
                className={styles.filterResetButton}
                onClick={() => {
                  trackEvent('clinic_productList_categoryFliter_reset');
                  onChanged([]);
                }}
              >
                <span>선택초기화</span>
                <img src={refreshIcon} alt="선택초기화" />
              </div>
            </div>
          </div>
        </FixSwipeable>
      )}
      {medicalCategoryProperties.length > MAX_LINE_FOR_SHOWING_CATEGORY_PROPERTIES && (
        <div
          className={styles.moreFilterRow}
          onClick={() => {
            setExpanded(!isExpanded);
          }}
        >
          {!isExpanded ? '필터 더보기' : '감추기'}
        </div>
      )}
      <div className={styles.horizonDivider} />
    </>
  );
}
